export const GET_ADDITIONAL_POSTS = `
    query GetAdditionalPosts($categoryIds: [ID!], $excludeIds: [ID!], $limit: Int!) {
      posts(
        where: {categoryIn: $categoryIds, notIn: $excludeIds, orderby: {field: DATE, order: DESC}}
        first: $limit
      ) {
        edges {
          node {
            title
            uri
            databaseId
            categories {
                nodes {
                    name
                    slug
                    databaseId
                    uri
                }
            }
            featuredImage {
              node {
                mediaDetails {
                  sizes {
                    height
                    width
                    sourceUrl
                  }
                }
                sourceUrl
                title
                altText
              }
            }
          }
        }
        pageInfo {
            endCursor
            total
          }
      }
    }
`;
